module.exports = __webpack_public_path__ + "static/img/pg.63d984fd.svg";